export const Client=[
    {
        "id":1,
        "title":"Joss Stefan",
        "country":"Australia",
        "text":"He Is Very Good Work on Web Design Specially Front End.I Am Full Satisfy with His Work",
        "img":"https://media.istockphoto.com/id/1198589068/photo/smiling-mature-businessman-sitting-at-office-desk-looking-at-camera.jpg?s=612x612&w=0&k=20&c=_BjMnHCFv2y7FYRG8FBwlggrUYy06oW82j817agOff8="
    },
    {
        "id":2,
        "title":"David",
        "country":"United State of America",
        "text":"He works very well. I got exactly what I wanted. I met his word and work. I am very happy with his work.",
        "img":"https://previews.123rf.com/images/stockbroker/stockbroker1507/stockbroker150705850/42307415-man-working-at-computer-in-contemporary-office.jpg"
    },
    {
        "id":3,
        "title":"Mathew Dore",
        "country":"Ireland",
        "text":"I gave him a full stake web page job and he delivered it on time and well",
        "img":"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbrH0IRK6qBLGE6t8_ieZHxqsfreom6_zZ7g&usqp=CAU"
    },
    {
        "id":4,
        "title":"Roger Alex",
        "country":"France",
        "text":"Parvez is very good web developer. I am happy with his work. He delivers work on time and works as promised",
        "img":"https://us.123rf.com/450wm/thelivephotos/thelivephotos2209/thelivephotos220900290/thelivephotos220900290.jpg?ver=6"
    },
    
    ]